import React, { useContext, useEffect, useState } from 'react';
import { ConjuntoType } from '../../../../service/Places';
import { UserContext } from '../../../../context/UserContext';
import { useTranslation } from 'react-i18next';
import Set from '../../../../service/Set';
import AttToken from '../../../../helpers/attToken';
import queryClient from '../../../../service/query';
import { toast } from 'react-toastify';
import { Autocomplete, Skeleton, TextField } from '@mui/material';
import ServiceTypes from '../../../../service/ServiceTypes';
import HeaderModal from '../../../HeaderModal/HeaderModal';
import FooterModal from '../../../FooterModal/FooterModal';
import QueryFn from '../../../../helpers/QueryFn';

type props = {
  open: boolean,
  setOpen: Function,
  set: ConjuntoType,
  getPlaces: Function
};

const services = new ServiceTypes();
const SetService = new Set();
const queryFn = new QueryFn();

export default function SetTypeAssoci({ open, setOpen, set, getPlaces }: props) {
  const { setChanged } = useContext(UserContext);
  const { t } = useTranslation('translation');
  const [selectedServices, setSelectedServices] = useState<string[]>(set.tiposServico || []);

  const { data, isLoading } = queryFn.useFetch('GET_SERVICES_FOR_PLACES',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          const response = await services.getAllServices({ ...token, empresa: token.userEmpresa });
          return response;
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    });

  const { mutate: updateSet } = queryFn.useMutate('UPDATE_PLACES', async () => {
    try {
      const token = await AttToken();
      if (token) {
        await SetService.addServiceType({ ...token }, selectedServices, set.id);
        getPlaces(set.cliente);
        setOpen(false);
        queryClient.resetQueries({ queryKey: ['Clientes'] });
        toast.success(`${t('Services.ServiceModal.typesAddedSuccessfully')}`);
      }
    }
    catch (err) {
      return console.log(err);
    }
  });

  const close = () => {
    setOpen(false);
    setSelectedServices([]);
  };

  const submit = () => {
    localStorage.setItem('changedHirarquia', 'true');
    setChanged(true);
    updateSet('');
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  return (
    <div className={`modal ${open ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onClick={() => close()} onKeyDown={escape} />
      <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <HeaderModal headerTitle={t('places.Associar_Tipos_de_Serviço')} close={close} />
        <div className="modal-card-body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            {isLoading
              ? <Skeleton variant='rounded' height={50} />
              : <Autocomplete
                multiple
                value={selectedServices?.map((ele) => {
                  const service = data?.find((elem: any) => elem.tipoId === ele);
                  return (
                    {
                      value: ele,
                      label: service ? service.nome : `${t('Services.ServiceModal.serviceNotFound')}`
                    }
                  );
                }) || null}
                id="combo-box-demo"
                sx={{ marginTop: '5px' }}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                filterSelectedOptions
                disableClearable
                options={
                  data
                    ?.filter((ele: any) => !selectedServices.includes(ele.tipoId))
                    ?.sort((a: any, b: any) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1; })
                    ?.map((ele: any) => ({
                      label: ele.nome,
                      value: ele.tipoId,
                    }))}
                onChange={(event: any, newValue: { label: string, value: string }[] | null, reason: any, details: any) => {
                  const value = details?.option.value;
                  if (selectedServices?.includes(value)) {
                    setSelectedServices((prevState) => prevState ? prevState.filter(el => el !== details.option.value) : []);
                  } else {
                    setSelectedServices([...selectedServices, value]);
                  }
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.value}>
                    <span>{option.label}</span>
                  </li>)}
                renderInput={(params) => <TextField {...params} label={t('Services.servicesManagement.kind')} />}
              />}
          </div>
        </div>
        <FooterModal disabled={false} submit={submit} label={`${t('save')}`} />
      </div>
    </div>
  );
}
